export default {

    uiBaseUrl: 'https://dutyfree.limeorlemon.com',
    apiBaseUrl: 'https://apidutyfree.limeorlemon.com',
    dashboardBaseUrl: 'https://dashboarddutyfree.limeorlemon.com'

    //uiBaseUrl: 'https://whatsyourraki.com',
    //apiBaseUrl: 'https://api.whatsyourraki.com',
    //dashboardBaseUrl: 'https://dashboard.whatsyourraki.com'
}